import '@vfde-brix/contact-us/dist/styles.css';

import { createContactUsComponent } from '@vfde-brix/contact-us';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';

const elements = document.getElementsByClassName('brix-contact-us');

for (let i = 0, x = elements.length; i < x; i += 1) {

    // traversing one up to get the container element
    const containerElement = elements[i].parentElement;

    createContactUsComponent(containerElement, NO_PATTERN_BUSINESS_LOGIC);

}
